export const SIGNUP = "SIGN UP";
export const SIGNIN = "SIGN IN";
export const CHANGE = "CHANGE";
